/*
 * @Description:
 * @Version: 1.0
 * @Author: changfeng
 * @Date: 2024-03-25 18:05:22
 * @LastEditors: changfeng
 * @LastEditTime: 2024-03-25 18:34:04
 */
import http from "@/api";

export const fetUpdateUserInfo = params => {
	return http.post("/admin/user/update", params);
};

export const updatePassword = params => {
	return http.post("/admin/user/update/password", params);
};
